import getAppState from 'app-state';
import { getLocale } from 'rcm-i18n';
import type { RcmReCaptcha2AppState, RcmReCaptcha2PublicConfig } from '../types';

/**
 * Get public config for ReCAPTCHA V2 from app state
 */
export default function getReCaptcha2PublicConfig(): RcmReCaptcha2PublicConfig {
  const { actions, apiSrc, enabled, localeConversion, localeDefault, siteKey } = getAppState<RcmReCaptcha2AppState>(
    'rcmReCaptcha2',
    {}
  );
  return {
    actions,
    apiSrc,
    enabled,
    locale: (localeConversion && localeConversion[getLocale()]) || localeDefault,
    siteKey,
  };
}
